export default __webpack_public_path__ + "static/media/profilepic.8739b186.jpg";